module.exports = __webpack_public_path__ + "img/notifications-dropdown.07c01d7e.svg";